import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment';
@Pipe({
  name: 'dateFormatter'
})
export class DateFormatterPipe implements PipeTransform {
  transform(value: string | Date) {
    const date: Date = typeof value === 'string' ? new Date(value) : value;
    const formatted = moment(date).format('ddd DD');
    return formatted;
  }
}



// WEBPACK FOOTER //
// ./src/pipes/date-formatter/date-formatter.ts